import React from 'react';
import {
  Link
} from 'react-router-dom';
import '../vendor/bootstrap.min';

/* Header component */
const Header = () => (
  <nav className="navbar navbar-inverse navbar-fixed-top" role="navigation">
    <div className="container">
        <div className="navbar-header">
            <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#navbar-collapse">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
            </button>
            <Link to="/"><span className="navbar-brand">BinaryOptions</span></Link>
        </div>
        <div className="collapse navbar-collapse" id="navbar-collapse">
            <ul className="nav navbar-nav">
              <li><Link to="/markets">Markets</Link></li>
              <li><Link to="/settings">Settings</Link></li>
              <li><Link to="/contact"> Contact Us </Link></li>
            </ul>
        </div>
    </div>
  </nav>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js